export default "__VITE_ASSET__JDg957N7__"